export const personalizationIdPropertyName = 'Personalization ID';
